import styled from 'styled-components'
import { fonts } from 'shared/lib'

const ModalPanelText = styled.div`
  ${fonts.BODY_TEXT}
`

export default ModalPanelText
